/* eslint-disable import/prefer-default-export */
import Analytics from '@ublend-npm/aula-analytics';
import { clientInfo } from './clientInfo';

export const init = async ({
  institution,
  user,
  spaceId,
  isInstructor,
  accessingAsStaff,
}) => {
  await Analytics.init(
    institution,
    // User
    {
      first_name: user.firstName,
      last_name: user.lastName,
      email: user.email,
      created_at: user.createdAt,
      userId: user.id,
      distinct_id: user.id,
      sessionStart: new Date().toISOString(),
      isAdmin: user.userRoles.includes('admin'),
    },
    // platform
    'web',
    // classRoom
    {
      isInstructor,
      accessingAsStaff,
      activeClassroom: spaceId,
    },
    // defaultProps
    {
      application: 'SSA',
      ...clientInfo,
    }
  );
  Analytics.setEndpoint(
    `https://apiv2.${institution}.aula.education/analytics`
  );
};
